// extracted by mini-css-extract-plugin
module.exports = {"PBF":"PBF_PBF__TN1h8","info":"PBF_info__1R8E8","data":"PBF_data__1lP95","container":"PBF_container__2HJLY","card":"PBF_card__3xjQf"};